import React, { Fragment } from 'react';
import PropTypes, { object } from 'prop-types';

import {
  Table,
  Button,
  Member,
  DateTime,
  CutIfToltip,
  TableCell
} from 'components/common/Elements/Elements';
import AdditionalContent from '../AdditionalContent/AdditionalContent';

import { links } from 'data/constants';
import { getInitialsFull } from 'utils/common';

import classes from './TicketsTable.module.scss';

const { freshdeskTickets } = links;

const TableRow = ({
  company,
  tableConf,
  row,
  mouseEnter,
  onOpenAdditionalModal
}) => {
  return (
    <Table.Row className={classes.row}>
      {tableConf.map(({ title, show, field }, ind) => {
        const cellProps = {
          row: row,
          mouseEnter: mouseEnter,
          ind: ind,
          field: field,
          classes: classes
        };

        return (
          <Fragment key={`${title}-${company._id}}`}>
            {show && field === 'ticketName' && (
              <TableCell cellProps={cellProps}>
                <CutIfToltip data={company.ticketName} length={80} />
              </TableCell>
            )}

            {show && field === 'messages' && (
              <TableCell cellProps={cellProps}>
                {company.messages &&
                company.messages.length > 0 &&
                company.messages[0].message.length > 0 ? (
                  <div>
                    {company.messages[0].message.substr(0, 100)}{' '}
                    {company.messages[0].message.length > 100 + 1 && (
                      <Button
                        className={classes.button}
                        onClick={() =>
                          onOpenAdditionalModal({
                            content: <AdditionalContent data={company} />
                          })
                        }
                      >
                        more...
                      </Button>
                    )}
                  </div>
                ) : (
                  'NA'
                )}
              </TableCell>
            )}
            {show && field === 'ticketId' && (
              <TableCell cellProps={cellProps}>
                <a
                  href={`${freshdeskTickets}${company.ticketId}`}
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  {company.ticketId}
                </a>
              </TableCell>
            )}
            {show && field === 'ticketStatus' && (
              <TableCell cellProps={cellProps}>
                {company.ticketStatus}
              </TableCell>
            )}
            {show && field === 'requesterName' && (
              <TableCell cellProps={cellProps}>
                <Member
                  member={{
                    fullName: company.requesterName,
                    description: company.requesterEmail,
                    initials: getInitialsFull(company.requesterName)
                  }}
                />
              </TableCell>
            )}
            {show && field === 'requesterRole' && (
              <TableCell cellProps={cellProps}>
                {company.requesterRole}
              </TableCell>
            )}
            {show && field === 'priority' && (
              <TableCell cellProps={cellProps}>{company.priority}</TableCell>
            )}
            {show && field === 'assigneeName' && (
              <TableCell cellProps={cellProps}>
                <Member
                  member={{
                    fullName: company.assigneeName,
                    description: company.assigneeEmail,
                    initials: getInitialsFull(company.assigneeName)
                  }}
                />
              </TableCell>
            )}
            {show && field === 'createdAt' && (
              <TableCell cellProps={cellProps}>
                <DateTime date={company.createdAt} time />
              </TableCell>
            )}
            {show && field === 'lastUpdatedAt' && (
              <TableCell cellProps={cellProps}>
                <DateTime date={company.lastUpdatedAt} time />
              </TableCell>
            )}
            {show && field === 'responseTime' && (
              <TableCell cellProps={cellProps}>
                {company.responseTime}
              </TableCell>
            )}
            {show && field === 'solvedAt' && (
              <TableCell cellProps={cellProps}>
                <DateTime date={company.solvedAt} time />
              </TableCell>
            )}
            {show && field === 'openToSolveTimeDays' && (
              <TableCell cellProps={cellProps}>
                {company.openToSolveTimeDays}
              </TableCell>
            )}
          </Fragment>
        );
      })}
    </Table.Row>
  );
};

TableRow.propTypes = {
  company: PropTypes.object,
  tableConf: PropTypes.arrayOf(object),
  row: PropTypes.string,
  mouseEnter: PropTypes.func,
  onOpenAdditionalModal: PropTypes.func.isRequired
};

export default TableRow;
